import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CURRENT_VIEW } from './constant';
import { Avatar } from 'react-chat-elements';
import { BackArrow } from '../../../assets/svg';
import {
    initializeChatUsers,
    initializeMessages,
    resetChatNotification,
    setCurrentView,
    setSelectedUser,
    toggleChatOpen,
} from '../../../redux';

const ChatHeader = ({ currentView, currentUser }) => {
    const onlineUsers = useSelector((s) => s.chat.onlineUsers);
    const dispatch = useDispatch();

    const handleBackFromNewChat = () => {
        dispatch(setCurrentView(CURRENT_VIEW.CHAT_VIEW));
        dispatch(initializeChatUsers([]));
    };

    const handleBackFromMessage = () => {
        dispatch(setCurrentView(CURRENT_VIEW.CHAT_VIEW));
        dispatch(setSelectedUser({}));
        dispatch(initializeMessages([]));
    };

    const handleCloseChat = () => {
        dispatch(setSelectedUser({}));
        dispatch(resetChatNotification());
        dispatch(initializeChatUsers([]));
        dispatch(toggleChatOpen());
        dispatch(setCurrentView(CURRENT_VIEW.CHAT_VIEW));
    };

    return (
        <div className='chat-header'>
            {currentView === CURRENT_VIEW.NEW_CHAT_VIEW && (
                <>
                    <button
                        className='d-flex align-items-center border-0 bg-transparent'
                        type='button'
                        onClick={handleBackFromNewChat}
                    >
                        <BackArrow />
                    </button>
                    <span className='ms-2 fw-bold fs-5 text-nowrap'>New Chat</span>
                </>
            )}
            {currentView === CURRENT_VIEW.MESSAGE_VIEW && (
                <span className='d-flex align-items-center gap-3'>
                    <button
                        className='d-flex align-items-center border-0 bg-white'
                        type='button'
                        onClick={handleBackFromMessage}
                    >
                        <BackArrow />
                    </button>
                    <span
                        title={`${onlineUsers.includes(currentUser?.user_id) ? 'Online' : 'Offline'}`}
                    >
                        <Avatar
                            src={currentUser?.avatar}
                            alt={currentUser?.title}
                            type='circle'
                            size={'small'}
                            sideElement={
                                <span
                                    className={`user-online-status ${onlineUsers?.includes(currentUser?.user_id) ? 'online' : 'offline'}`}
                                ></span>
                            }
                        />
                    </span>
                    <span className='ms-1 fw-medium'>{currentUser?.title}</span>
                </span>
            )}
            {(CURRENT_VIEW.CHAT_VIEW === currentView ||
                CURRENT_VIEW.NEW_CHAT_VIEW === currentView) && (
                <div className='d-flex w-100 align-items-center justify-content-between gap-2'>
                    {CURRENT_VIEW.CHAT_VIEW === currentView && (
                        <span className='fw-bold fs-5 text-nowrap'>{`SSC Chat`}</span>
                    )}
                </div>
            )}
            <button className='btn-close' onClick={handleCloseChat} />
        </div>
    );
};

export default ChatHeader;
